import { render, staticRenderFns } from "./mzjz.vue?vue&type=template&id=d52de0cc&scoped=true&"
import script from "./mzjz.vue?vue&type=script&lang=js&"
export * from "./mzjz.vue?vue&type=script&lang=js&"
import style0 from "./mzjz.vue?vue&type=style&index=0&id=d52de0cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52de0cc",
  null
  
)

export default component.exports